import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Tab,
  Row,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { tambahUser, getAllClient } from "stores";
import { useDispatch, useSelector } from "react-redux";
import { getAllUser } from "stores";
import { editStatusUser } from "stores";
import { Dna } from "react-loader-spinner";
import { settingMenuUser } from "stores";

function ListUser() {
  const dispatch = useDispatch();
  const storeClient = useSelector((state) => state.clientReducer);
  const user = useSelector((state) => state.userReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [pilihJabatan, setPilihJabatan] = React.useState(null);
  const [role, setRole] = React.useState("");
  const [listUser, setListUser] = React.useState([]);
  const [pilihMenu, setPilihMenu] = React.useState(null);
  const [pilihClient, setPilihClient] = React.useState([]);
  const [idUser, setIdUser] = React.useState("");
  const [idClient, setIdClient] = React.useState("");
  const [modalUser, setModalUser] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listClient, setListClient] = React.useState([]);
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [modalSettingMenu, setModalSettingMenu] = React.useState(false);
  const [multipleSelect, setMultipleSelect] = React.useState([]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const submitUser = () => {
    tambahUser({
      nama: nama,
      nopeg: nopeg,
      role: role,
      idClient: idClient,
    })
      .then((response) => {
        // console.log(response);
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            showConfirmButton: false,
            title: response.data.message,
            timer: 1000,
          });
          handleModalClose();
          getAllUser(dispatch);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const handleModalClose = () => {
    setModalUser(false);
    setPilihClient(null);
    setPilihJabatan(null);
    setIdClient("");
    setPilihJabatan("");
  };

  const submitSettingMenu = () => {
    const dataToSend = {
      idUser: idUser,
      menu: multipleSelect.map((option) => option.value),
    };
    settingMenuUser(dataToSend)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllUser(dispatch, { idClient: "" });
          setModalSettingMenu(false);
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusUser({
      idUser: idUser,
      status: status.value,
    })
      .then((response) => {
        // console.log(response, ">>>>>>>>>>>>");
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000,
          });
          getAllUser(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  // const submitEdit = () => {
  //   Swal.fire({
  //     title: "Tunggu ...",
  //     didOpen() {
  //       Swal.showLoading();
  //     },
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //     allowEnterKey: false,
  //   });
  //   if (nama === "" || nopeg === "" || pilihClient === "") {
  //   } else {
  //     tambahUser({
  //       nama: nama,
  //       nopeg: nopeg,
  //       role: role,
  //       idClient: idClient,
  //     }).then((response) => {
  //       console.log(response);
  //       if (response === 200) {
  //         Swal.close();
  //         setModalPenempatan(false);
  //         setIdClient("");
  //         setPilihClient("");
  //       }
  //     });
  //   }
  // };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  React.useEffect(() => {
    getAllUser(dispatch, { idClient: "" })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    getAllClient(dispatch);
  }, []);

  React.useEffect(() => {
    let tmp =
      user.listUser &&
      user.listUser.map((val) => {
        return {
          ...val,
          action: (
            <div className="d-flex align-items-center">
              {val.role !== "super admin" ? (
                <>
                  {/* TOMBOL EDIT STATUS */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-edit-${val._id}`}>
                        Edit Status
                      </Tooltip>
                    }
                  >
                    <Button
                      className="btn-icon d-flex align-items-center justify-content-center"
                      style={{
                        marginTop: 5,
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#10b981", // Emerald Green
                        borderRadius: "12px",
                        border: "none",
                        color: "white",
                        boxShadow: "0 4px 10px rgba(16, 185, 129, 0.2)",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => {
                        setIdUser(val._id);
                        setModalEdit(!modalEdit);
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = "#059669";
                        e.currentTarget.style.transform = "translateY(-2px)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = "#10b981";
                        e.currentTarget.style.transform = "translateY(0)";
                      }}
                    >
                      <i
                        className="fas fa-user-edit"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL SETTING MENU (Hanya untuk Super Admin) */}
                  {auth.role === "super admin" ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-menu-${val._id}`}>
                          Setting Menu
                        </Tooltip>
                      }
                    >
                      <Button
                        className="ml-2 d-flex align-items-center justify-content-center shadow-sm"
                        style={{
                          marginTop: 5,
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#2e3192", // Biru BPR Jatim
                          borderRadius: "12px",
                          border: "none",
                          color: "white",
                          boxShadow: "0 4px 10px rgba(46, 49, 146, 0.2)",
                          transition: "all 0.3s ease",
                        }}
                        onClick={() => {
                          setModalSettingMenu(!modalSettingMenu);
                          setIdUser(val._id);
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor = "#1e2170";
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor = "#2e3192";
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        <i
                          className="fas fa-cog"
                          style={{ fontSize: "16px" }}
                        ></i>
                      </Button>
                    </OverlayTrigger>
                  ) : null}
                </>
              ) : (
                <span className="text-muted fw-bold ml-2">—</span>
              )}
            </div>
          ),
        };
      });
    setListUser(tmp);
  }, [user.listUser, auth, modalEdit, modalSettingMenu]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9", // Abu-abu biru muda (Very Clean)
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        justifyContent: "flex-start", // Lurus Kiri
        paddingLeft: "20px",
      },
    },
    rows: {
      style: {
        minHeight: "75px", // Row agak tinggi agar teks besar tidak sesak
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "flex-start", // Lurus Kiri
        paddingLeft: "20px",
      },
    },
  };

  const colUser = [
    {
      name: "NO",
      width: "70px",
      center: false,
      cell: (row, index) => (
        <span className="fw-800 text-muted ml-1" style={{ fontSize: "14px" }}>
          {(currentPage - 1) * itemsPerPage + index + 1}
        </span>
      ),
    },
    {
      name: "PROFIL USER",
      minWidth: "280px",
      center: false,
      cell: (row) => (
        <div className="d-flex align-items-center ml-1 py-2">
          <div
            className="mr-3 d-flex align-items-center justify-content-center rounded-circle shadow-sm"
            style={{
              width: "45px",
              height: "45px",
              background: "linear-gradient(135deg, #2e3192 0%, #1e293b 100%)",
              color: "white",
              fontSize: "16px",
              fontWeight: "900",
            }}
          >
            {row.nama.charAt(0).toUpperCase()}
          </div>
          <div>
            <span
              className="fw-900 text-dark d-block"
              style={{ fontSize: "16px", lineHeight: "1.2" }}
            >
              {row.nama}
            </span>
            <span
              className="text-muted"
              style={{ fontSize: "14px", fontWeight: "900" }}
            >
              {row.nopeg}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "JABATAN",
      minWidth: "180px",
      center: false,
      cell: (row) => (
        <div className="ml-1">
          <span
            className={`badge px-3 py-2 fw-800 ${row.role === "admin" ? "bg-light text-danger border-danger" : "bg-light text-primary border-primary"}`}
            style={{
              borderRadius: "8px",
              fontSize: "12px",
              border: "1px solid",
            }}
          >
            {row.role === "admin" ? "ADMIN" : "CLIENT"}
          </span>
        </div>
      ),
    },
    {
      name: "PENEMPATAN BPD",
      minWidth: "220px",
      center: false,
      cell: (row) => (
        <div className="ml-1 d-flex align-items-center fw-700 text-dark">
          <i className="fas fa-building mr-2 text-muted"></i>
          {row.penempatan ? row.penempatan : "-"}
        </div>
      ),
    },
    {
      name: "STATUS AKUN",
      minWidth: "180px",
      center: false,
      cell: (row) => {
        const statusStyle = getStatusUser(row.status);
        const isAktif = row.status === "aktif";

        return (
          <div
            className="ml-1 d-flex align-items-center justify-content-center"
            style={{
              fontWeight: "800",
              backgroundColor: isAktif ? "#dcfce7" : "#fee2e2",
              color: isAktif ? "#15803d" : "#b91c1c",
              padding: "8px 16px",
              borderRadius: "50px",
              fontSize: "12px",
              minWidth: "110px",
              textTransform: "uppercase",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            }}
          >
            <span
              className="mr-2"
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isAktif ? "#15803d" : "#b91c1c",
              }}
            />
            {isAktif ? "Aktif" : "Non-Aktif"}
          </div>
        );
      },
    },
    {
      name: "AKSI",
      minWidth: "120px",
      center: false,
      cell: (row) => (
        <div className="ml-1" style={{ transform: "scale(1.1)" }}>
          {row.action}
        </div>
      ),
    },
  ];

  return (
    <>
      <Modal
        size="md" // Ukuran MD lebih pas untuk satu input select
        show={modalSettingMenu}
        onHide={() => setModalSettingMenu(!modalSettingMenu)}
        centered
        contentClassName="border-0"
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: "#f0fdf4",
                borderRadius: "15px",
                color: "#10b981",
              }}
            >
              <i className="fas fa-cog fa-2x"></i>
            </div>
            <h4 className="font-weight-bold m-0" style={{ color: "#1e293b" }}>
              SETTING MENU
            </h4>
            <p className="text-muted small">
              Tentukan hak akses menu untuk user ini
            </p>
          </div>

          <Form.Group>
            <label className="small fw-800 text-muted text-uppercase mb-2 d-block">
              Pilih Akses Menu
            </label>
            <Select
              className="react-select info shadow-sm"
              classNamePrefix="react-select"
              placeholder="Cari & Pilih Menu..."
              isMulti
              value={multipleSelect}
              onChange={(value) => setMultipleSelect(value)}
              options={[
                { value: "Dashboard", label: "Dashboard" },
                { value: "Client", label: "Client" },
                { value: "User", label: "User" },
                { value: "Cabang", label: "Cabang" },
                { value: "Target", label: "Target" },
                { value: "Pengajuan", label: "Pengajuan" },
                { value: "Pencairan", label: "Pencairan" },
                { value: "Kunjungan", label: "Kunjungan" },
                { value: "ListKunjungan", label: "Kunjungan Marketing" },
              ]}
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  padding: "5px",
                }),
                multiValue: (base) => ({
                  ...base,
                  backgroundColor: "#2e3192",
                  color: "white",
                  borderRadius: "8px",
                }),
                multiValueLabel: (base) => ({
                  ...base,
                  color: "white",
                  fontWeight: "bold",
                }),
              }}
            />
          </Form.Group>

          <Button
            className="btn-block py-3 mt-4 border-0 shadow-sm fw-800"
            style={{
              background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={submitSettingMenu}
          >
            SIMPAN PERUBAHAN
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        size="sm" // Status cukup ukuran kecil (Small)
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(!modalEdit);
        }}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4 text-center">
          <div className="mb-3">
            <i
              className="fas fa-toggle-on fa-3x text-primary"
              style={{ color: "#2e3192" }}
            ></i>
          </div>
          <h4 className="font-weight-bold mb-1">EDIT STATUS</h4>
          <p className="text-muted small mb-4">
            Aktifkan atau nonaktifkan akun ini
          </p>

          <Select
            className="react-select primary text-left shadow-sm"
            classNamePrefix="react-select"
            value={status}
            onChange={(selectedOption) => setStatus(selectedOption)}
            options={[
              { value: "true", label: "✅ Aktif" },
              { value: "false", label: "❌ Tidak Aktif" },
            ]}
            placeholder="Pilih Status..."
            styles={{ control: (base) => ({ ...base, borderRadius: "10px" }) }}
          />

          <Button
            className="btn-block py-3 mt-4 border-0 fw-800"
            style={{
              background: "#2e3192",
              borderRadius: "10px",
              color: "white",
            }}
            onClick={checkStatus}
          >
            UPDATE STATUS
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalUser}
        onHide={() => {
          handleModalClose();
          setModalUser(false);
        }}
        centered
        contentClassName="border-0 shadow-2xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-5 pb-5">
          <div className="d-flex align-items-center mb-4">
            <div
              className="p-3 mr-3"
              style={{ background: "#f90203", borderRadius: "15px" }}
            >
              <i className="fas fa-user-plus text-white fa-lg"></i>
            </div>
            <div>
              <h3 className="m-0 font-weight-bold" style={{ color: "#1e293b" }}>
                TAMBAH USER
              </h3>
              <p className="m-0 text-muted">
                Daftarkan personil baru ke sistem BPR JATIM
              </p>
            </div>
          </div>

          <Form>
            <Row>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Nama Lengkap
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm"
                    style={{
                      backgroundColor: "#f8fafc",
                      height: "50px",
                      borderRadius: "10px",
                    }}
                    onChange={(e) => setNama(e.target.value)}
                    placeholder="Masukkan Nama Lengkap"
                    type="text"
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Username / Nopeg
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm"
                    style={{
                      backgroundColor: "#f8fafc",
                      height: "50px",
                      borderRadius: "10px",
                    }}
                    onChange={(e) => setNopeg(e.target.value)}
                    placeholder="Masukkan Username"
                    type="text"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Jabatan / Role
                  </label>
                  <Select
                    className="react-select primary"
                    classNamePrefix="react-select"
                    value={pilihJabatan}
                    onChange={(value) => {
                      setRole(value.value);
                      setPilihJabatan(value);
                    }}
                    options={[
                      { value: "admin", label: "Admin Internal" },
                      { value: "client", label: "Client (BPD)" },
                    ]}
                    placeholder="Pilih Jabatan..."
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "10px",
                        height: "50px",
                        border: "none",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                      }),
                    }}
                  />
                </Form.Group>
              </Col>

              {auth.role === "super admin" && (
                <Col md="6">
                  <Form.Group className="mb-3">
                    <label className="small fw-800 text-dark text-uppercase">
                      Assign ke Client
                    </label>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      value={pilihClient}
                      onChange={(value) => {
                        setPilihClient(value);
                        setIdClient(value.value);
                      }}
                      options={listClient}
                      placeholder="Pilih Client..."
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "10px",
                          height: "50px",
                          border: "none",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                        }),
                      }}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>

            <div className="mt-4 pt-3">
              {/* TOMBOL UTAMA (SIMPAN) */}
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-sm animate-press"
                style={{
                  background:
                    "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                  borderRadius: "15px",
                  color: "white",
                  fontSize: "16px",
                  letterSpacing: "1px",
                }}
                onClick={submitUser}
              >
                <i className="fas fa-check-circle mr-2"></i>
                SIMPAN USER BARU
              </Button>

              {/* TOMBOL BATAL (DIBUAT LEBIH SOFT DI BAWAH) */}
              <Button
                variant="link"
                className="btn-block mt-2 text-muted fw-700 text-decoration-none"
                style={{ fontSize: "14px" }}
                onClick={() => {
                  handleModalClose();
                  setModalUser(false);
                }}
              >
                Batalkan Penginputan
              </Button>
            </div>
          </Form>
        </Modal.Body>

        <style>{`
    .fw-900 { font-weight: 900; }
    .animate-press:active { transform: scale(0.98); transition: 0.1s; }
    
    /* Efek Glow pada tombol simpan */
    .btn-block:hover {
      box-shadow: 0 10px 20px rgba(249, 2, 3, 0.2) !important;
      opacity: 0.9;
    }
  `}</style>
      </Modal>

      <Tab.Content>
        {/* AREA FILTER & ACTION */}
        <div className="px-4 py-2 bg-white">
          <Row className="align-items-center justify-content-between">
            {/* Kolom Tombol Tambah */}
            <Col md="4" xs="12" className="mb-3 mb-md-0">
              <Button
                className="btn-fill btn-wd d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  marginTop: "10px",
                  background:
                    "linear-gradient(135deg, #f90203 0%, #ff4d4d 100%)",
                  fontWeight: "900",
                  border: 0,
                  borderRadius: "12px",
                  padding: "10px 25px",
                  fontSize: "14px",
                  letterSpacing: "0.5px",
                }}
                onClick={() => setModalUser(!modalUser)}
              >
                <i className="fas fa-user-plus mr-2"></i>
                TAMBAH USER
              </Button>
            </Col>

            {/* Kolom Search Bar */}
            <Col md="4" xs="12">
              <InputGroup
                className="shadow-none border rounded-lg"
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  backgroundColor: "#f8fafc",
                }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text className="bg-transparent border-0">
                    <i className="fas fa-search text-muted"></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  className="border-0 bg-transparent"
                  style={{
                    paddingLeft: "5px",
                    height: "45px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="Cari No. Karyawan / Nama..."
                />
              </InputGroup>
            </Col>
          </Row>
        </div>

        <hr className="mx-4 my-4" style={{ opacity: "0.05" }} />

        {/* AREA TABLE / LOADER */}
        <div className="px-4 pb-4">
          {isLoading ? (
            <div
              className="loader-container d-flex flex-column align-items-center justify-content-center"
              style={{
                minHeight: "40vh",
                background: "#f8fafc",
                borderRadius: "20px",
              }}
            >
              <Dna
                visible={true}
                height="100"
                width="100"
                ariaLabel="dna-loading"
                wrapperStyle={{}}
                wrapperClass="dna-wrapper"
              />
              <h6
                className="mt-3 font-weight-bold text-muted"
                style={{ letterSpacing: "2px" }}
              >
                MENYIAPKAN DATA...
              </h6>
            </div>
          ) : (
            <div className="table-responsive rounded-xl shadow-sm border">
              <DataTable
                columns={colUser}
                data={listUser.filter(
                  (row) =>
                    row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
                    row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
                )}
                customStyles={{
                  ...customStyles,
                  rows: {
                    style: {
                      minHeight: "65px",
                      "&:hover": {
                        backgroundColor: "#f1f5f9",
                        transition: "0.2s",
                      },
                    },
                  },
                }}
                pagination
                paginationPerPage={itemsPerPage}
                onChangePage={handlePageChange}
                highlightOnHover
                pointerOnHover
              />
            </div>
          )}
        </div>

        <style>{`
    .rounded-xl { border-radius: 15px !important; overflow: hidden; }
    .btn-fill { transition: all 0.3s ease; }
    .btn-fill:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(249, 2, 3, 0.3) !important; }
    
    /* Search Bar Focus Style */
    .input-group:focus-within {
      border-color: #2e3192 !important;
      box-shadow: 0 0 0 0.2rem rgba(46, 49, 146, 0.1) !important;
    }
  `}</style>
      </Tab.Content>
    </>
  );
}

export default ListUser;
